export default __webpack_public_path__ + "static/media/icon.flashlights.8430f836.svg";